import React, { useEffect, useState, useRef } from 'react'
import { AutoComplete } from 'primereact/autocomplete'
import { getAdditionalSccs } from '../../../services/searchPanelServices'
import { useDispatch, useSelector } from "react-redux";
import { setMasterDataDetails } from "../../../redux/actions/masterDataActions";

const HawbSccAutoComplete = ({
	shipmentDetails,
	handleAddAdditinalScc,
	setAlertMessage,
	setSuccess,
	disabled = false,
}) => {
	const [text, setText] = useState(null)
	const [sccs, setSccs] = useState([])
	const [filteredSccItems, setfilteredSccItems] = useState([])

	const myRef = useRef()
	const masterData = useSelector(state => state?.masterData);
	const dispatch = useDispatch();

	// useEffect(() => {
	// 	getAdditionalSccs()
	// 		.then((sccs) => {
	// 			setSccs(sccs)
	// 		})
	// 		.catch((err) => {
	// 			setAlertMessage &&
	// 				setAlertMessage('Additional Sccs Error' + err.message)
	// 			setSuccess && setSuccess(false)
	// 		})
	// }, [])
	useEffect(() => {

		if (masterData?.additionalSccsMaster && masterData.additionalSccsMaster.length > 0) {
			setSccs([...masterData.additionalSccsMaster])
		} else {

			getAdditionalSccs()
				.then((sccs) => {
					setSccs(sccs)


					if (sccs && sccs.length > 0) {
						const masterDataPayload = {
							additionalSccsMaster: sccs
						}
						dispatch(setMasterDataDetails(masterDataPayload))
					}
				})
				.catch((err) => {
					setAlertMessage &&
						setAlertMessage('Additional Sccs Error: ' + err.message)
					setSuccess && setSuccess(false)
				})
		}
	}, [])

	const searchSccItems = () => {
		const shippingItemByCodeStart =
			sccs && sccs.length && text && text.length
				? sccs.filter((scc) => {
						return scc.scc.toLowerCase().startsWith(text.toLowerCase())
				  })
				: []

		const shippingItemByNameStart =
			sccs && sccs.length && text && text.length
				? sccs.filter((scc) => {
						return ` ${scc.sccDescription.toLowerCase()}`.startsWith(
							text.toLowerCase()
						)
				  })
				: []

		const shippingItemByContains =
			sccs && sccs.length && text && text.length
				? sccs.filter((scc) => {
						return (
							scc.scc.toLowerCase().includes(text.toLowerCase()) ||
							scc.sccDescription.toLowerCase().includes(text.toLowerCase())
						)
				  })
				: []

		const filteredSccItems = [
			...shippingItemByNameStart,
			...shippingItemByCodeStart,
			...shippingItemByContains,
		].filter(
			(item, index, self) =>
				index === self.findIndex((i) => i.scc === item.scc)
		)

		setfilteredSccItems(filteredSccItems)
	}
	//console.log('filteredSccItems',filteredSccItems)

	const itemTemplate = (scc) => {
		return (
			<div className='scc-autocomplete'>
				<span className='scc-code'>{` ${scc.scc}`}</span>
				<span className='scc-description-hawb'>{` ${scc.sccDescription}`}</span>
			</div>
		)
	}

	return (
		<>
			<AutoComplete
				value={text ?? shipmentDetails?.scc ?? ''}
				suggestions={filteredSccItems}
				ref={myRef}
				completeMethod={searchSccItems}
				disabled={disabled}
				onChange={(e) => {
					setText(e.value)
					if (!e.value) {
						// Clear selected SCC in parent when input is cleared
						handleAddAdditinalScc(null)
					}
				}}
				onSelect={(e) => {
					setText(e.value.scc) 
					handleAddAdditinalScc(e.value.scc)
				}}
				onBlur={() => {
					if (!text) {
						// If nothing typed, don’t restore old SCC
						return
					}

					if (filteredSccItems && filteredSccItems.length > 0) {
						const item = filteredSccItems[0]
						setText(item.scc)
						handleAddAdditinalScc(item.scc)
					}
				}}
				className={'form-control autocomplete search-panel__scc-autocomplete'}
				itemTemplate={itemTemplate}
			/>
		</>
	)
}

export default HawbSccAutoComplete
